



































import { EventBus } from '@/plugins/event-bus';
import {Vue, Component} from "vue-property-decorator";
import TextToSpeech from "@/components/TextToSpeech.vue";
import SpeechToText from "@/components/SpeechToText.vue";
import {State} from "vuex-class";
import {PracticeInterface} from "@/models/Practice";

@Component({
    components:{
        TextToSpeech, SpeechToText
    }
})
export default class BotPractices extends Vue{
    public contadorActivity = 1;
    @State(state => state.practice.practices) practices: PracticeInterface[];
    public sentences: any[] = []
    public response = '';


    speechEnd({sentences}: { sentences: any; text: any }) {
        this.sentences = sentences
    }

    validateVoice(){
        const textArray = this.response.split(' ');
        const valid: boolean[] = [];
        textArray.forEach((e: string) => {
            if (this.lastPractice[0].response.includes(e)){
                valid.push(true)
            }else {
                valid.push(false)
            }
        });

        if (valid.includes(true)){
            this.response = '';

            this.contadorActivity++
        }else {
            this.response = '';
            this.contadorActivity = 1
        }

    }

    get lastPractice(){
        return this.practices.filter((e: PracticeInterface) => {
            return e.order == this.contadorActivity;
        })
    }


    created(){
        this.$store.dispatch('bindPractice', 'asc')
    }
}
